<script setup lang="ts">
interface PaymentMethod {
    alt: string
    component: Component
}

interface PaymentMethodsProps {
    paymentMethods?: PaymentMethod[]
}
defineProps<PaymentMethodsProps>()
</script>

<template>
    <div class="payment-methods">
        <span
            v-for="paymentMethod in paymentMethods"
            :key="paymentMethod.alt"
            class="payment__logo"
            :title="paymentMethod.alt"
        >
            <component :is="paymentMethod.component" />
        </span>
    </div>
</template>

<style lang="scss" scoped>
.payment-methods {
    z-index: 4;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 4px;
    z-index: 6;
    margin-top: 20px;
    height: 22px;

    @media (min-width: $screen-md) {
        margin-top: 30px;
    }
}

.payment__logo {
    position: relative;
    display: inline-flex;

    svg {
        height: auto;
        width: auto;
        max-width: 100%;
        max-height: 100%;
        vertical-align: middle;
    }
}
</style>
